export default __webpack_public_path__ + "traffic-signs-header-image-480-f2c62b23b4075ee366ab086bb205dd92.png";